import { AppButton, AppFormInput } from '@components/AppComponents'
import AppModal from '@components/AppModal'
import { Flex } from '@components/Layout'
import { ApiService } from '@services/ApiService'
import { useState } from 'react'

interface Props {
  tenantId: string
  storageLimit: number
  onClose: () => void
}
const MaxFileSizeSettingModal = (props: Props) => {
  const [loading, setLoading] = useState(false)
  const [maxFileSize, setMaxFileSize] = useState(props.storageLimit)

  const handleSave = async () => {
    try {
      setLoading(true)
      await ApiService.FileManager.SetFileSizeLimit(props.tenantId, maxFileSize) // Example value, replace with actual input
    } finally {
      setLoading(false)
    }
    props.onClose()
  }

  return (
    <AppModal
      footer={
        <Flex>
          <AppButton
            onClick={() => handleSave()}
            color="green"
            rounded
            loading={loading}
          >
            Save
          </AppButton>
          <AppButton
            onClick={() => {
              props.onClose()
            }}
            color="red"
            rounded
          >
            Close
          </AppButton>
        </Flex>
      }
      open={true}
      onCancel={() => {}}
      title="Storage Limit"
    >
      <AppFormInput
        type="number"
        label="Storage Limit (GB)"
        className="w-full"
        value={maxFileSize}
        min={0}
        onChange={value => setMaxFileSize(Number(value))}
      />
    </AppModal>
  )
}

export default MaxFileSizeSettingModal
